import {
  Theme,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants,
} from '@mui/material/styles';

/**
 * Replicates Material-UI v4 Grid gutters (uniform item padding = spacing/2, container
 * width + full spacing, negative margin spacing/2) so migrated layouts match v4
 * while keeping global `theme.spacing()` unchanged.
 *
 * @see https://v4.mui.com/components/grid/#spacing
 */
const SPACINGS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const;
const UPPER_BREAKPOINTS = ['sm', 'md', 'lg', 'xl', 'xxl'] as const;

function v4ContainerGutter(theme: Theme, n: number) {
  const full = theme.spacing(n);
  const half = `calc(${full} / 2)`;
  return {
    width: `calc(100% + ${full})`,
    margin: `calc(-1 * ${half})`,
    '& > .MuiGrid-item': {
      padding: half,
    },
  };
}

function buildSpacingSlotOverrides(): ComponentsOverrides<Theme>['MuiGrid'] {
  const styleOverrides: Record<string, unknown> = {};

  for (const n of SPACINGS) {
    styleOverrides[`spacing-xs-${n}`] = ({ theme }: { theme: Theme }) =>
      v4ContainerGutter(theme, n);

    for (const bp of UPPER_BREAKPOINTS) {
      styleOverrides[`spacing-${bp}-${n}`] = ({ theme }: { theme: Theme }) => ({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        [theme.breakpoints.up(theme.breakpoints.values[bp])]: v4ContainerGutter(
          theme,
          n,
        ),
      });
    }
  }

  return styleOverrides as ComponentsOverrides<Theme>['MuiGrid'];
}

const muiGrid: {
  defaultProps?: ComponentsProps['MuiGrid'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiGrid'];
  variants?: ComponentsVariants['MuiGrid'];
} = {
  styleOverrides: buildSpacingSlotOverrides(),
};

export default muiGrid;
